import { Study } from '@models';

function parseToLineChartData(
  name: string,
  data: Study[],
  groupByFn: (study: Study) => string
): Record<string, Study[] | undefined> {
  const studiesByGroup = Object.groupBy(data, groupByFn);
  const groupEntries = Object.entries(studiesByGroup);

  if (name === 'studyPhase') {
    const order = ['No Phase', 'Phase IV', 'Phase III', 'Phase II', 'Phase I'];
    groupEntries.sort((a, b) => order.indexOf(a[0]) - order.indexOf(b[0]));
  } else {
    groupEntries.sort(([, arrA], [, arrB]) => (arrA?.length || 0) - (arrB?.length || 0));
  }

  if (name === 'therapeuticArea') {
    const notAvailableIndex = groupEntries.findIndex(([key]) => key === 'Not available');
    if (notAvailableIndex !== -1) {
      const [notAvailableEntry] = groupEntries.splice(notAvailableIndex, 1);
      groupEntries.unshift(notAvailableEntry);
    }
  }

  if (name === 'studyStage') {
    const customOrder = [
      'Startup',
      'Enrollment',
      'Maintenance',
      'Closeout',
      'All Milestones Completed'
    ];
    groupEntries.sort((a, b) => customOrder.indexOf(b[0]) - customOrder.indexOf(a[0]));
  }

  return Object.fromEntries(groupEntries);
}

export { parseToLineChartData };
